import { el, mount, unmount, setChildren } from 'redom';

import application from 'application';

import internalEventCodes from 'event-system/codes/internal';

import AttendeeMode from './attendee-mode';

import StreamingBackgroundImage from 'assets/images/event-background-image.png';

class ViewerMode extends AttendeeMode {

  constructor(currentUserId, meeting, post, displayedLiveStreamView) {

    super(currentUserId, meeting, post, {
      outputAudio: true
    });

    this.autoJoin = false;
    this.displayedLiveStreamView = displayedLiveStreamView;
    this.el = el('.viewer-mode-container', [
      el('ht-spinner', {
        size: 'small'
      })
    ]);

  }

  onmount() {

    this.initialize();

  }

  onunmount() {

    // unmount(this.el, this.meetingRoom);
    // unmount(this.el, this.startButton);
    // unmount(this.el, this.resumeButton);
    // unmount(this.el, this.joinButton);

    this.el = null;

  }

  displayJoinView() {

    this.backgroundImageEl = el('img.live-view-viewer-mode-background-image', { src: StreamingBackgroundImage, alt: 'streaming background image' });

    this.meetingStartedLabelEl = el('label.meeting-started-label', 'Streaming is in progress, please join.');

    this.joinButton = el('button.join-meeting-button', this.getJoinButtonText());

    this.joinButton.addEventListener('click', this.handleJoinButtonClick.bind(this));

    this.joinView = el('.join-meeting-view', [this.backgroundImageEl, this.meetingStartedLabelEl, this.joinButton]);

    setChildren(this.el, [this.joinView]);

  }

  unmountJoinView() {

    unmount(this.el, this.joinView);

  }

  getJoinButtonText() {

    if (this.currentUserId === this.meeting.ownerId) {
      return 'Go Live from here';
    }

    return 'Join';

  }

  async initialize() {

    if (this.currentUserId === null) {
      this.displayJoinView();
      return;
    }

    if (this.displayedLiveStreamView === true) {
      await this.startMeeting({ audio: true, video: false });
    } else {
      this.displayJoinView();
    }

  }

  async handleJoinButtonClick(event) {

    event.stopPropagation();

    if (application.isAuthenticated() === false) {
      return application.eventSystem.internal.emit(internalEventCodes.DISPLAY_AUTHENTICATOR);
    }

    application.eventSystem.internal.emit(internalEventCodes.NAVIGATE_TO, {
      to: `/community/${this.post._id}/live`
    });

  }

  doLeaveMeeting() {
    return false;
  }

  mountNextView() {

    application.eventSystem.internal.emit(internalEventCodes.NAVIGATE_TO, {
      to: `/community/${this.post.humanFriendlyId}`
    });

  }

}

export default ViewerMode;